export default "__VITE_ASSET__81918b22__"